import { api } from "./client";

export interface CurrentUser {
  id: string;
  email: string;
  role: string;
  provider: string;
  created_at: string;
  avatar_url?: string;
  first_name?: string | null;
  last_name?: string | null;
  settings: Record<string, any>;
}

export interface UserProfileUpdate {
  first_name?: string | null;
  last_name?: string | null;
  email?: string;
  custom_avatar?: string | null;
  current_password?: string;
  new_password?: string;
}

export const userApi = {
  getMe: async (): Promise<CurrentUser> => {
    const response = await api.get<CurrentUser>("/api/user/me");
    return response.data;
  },
  updateProfile: async (data: UserProfileUpdate): Promise<CurrentUser> => {
    const response = await api.put<CurrentUser>("/api/user/profile", data);
    return response.data;
  },
  updateSettings: async (settings: Record<string, any>): Promise<Record<string, any>> => {
    const response = await api.put<Record<string, any>>("/api/user/settings", settings);
    return response.data;
  },
};
